import Vue from 'vue'
import VueRouter from 'vue-router'
import IndexView from '../views/IndexView.vue'

// 直接引入所有组件（禁用懒加载，根治chunk错误）
import indexPage from '../components/indexPage.vue'
import message from '../components/message.vue'
import subEvents from '../components/subEvents.vue'
import submit from '../components/submit.vue'
import subscribe from '../components/subscribe.vue'
import PersonalCenter from '../components/PersonalCenter.vue'
import about from '../components/about.vue'
import eventsDetail from '../components/infoPage/eventsDetail.vue'
import Notice from '../components/infoPage/Notice.vue'
import Circulars from '../components/infoPage/Circulars.vue'
import Atel from '../components/infoPage/atel.vue'
import Customize from '../components/infoPage/Customize.vue'
import submitList from '../components/submitList.vue'
import viewDataInfo from '../components/viewDataInfo.vue'
import showSubmitInfo from '../components/showSubmitInfo.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'indexMaster',
    component: IndexView,
    redirect: 'indexPage',
    children: [
      {
        path: 'indexPage',
        component: indexPage,
        meta: {
          title: 'HOME',
          requiresAuth: false,
          keepAlive: true
        }
      },
      {
        path: 'message',
        component: message,
        meta: {
          title: 'MESSAGE',
          requiresAuth: false,
        },
      },
      {
        path: 'events',
        component: subEvents,
        meta: {
          title: 'EVENTS',
          requiresAuth: false,
        }
      },
      {
        path: 'target_visibility',
        beforeEnter: (to, from, next) => {
          window.location.href = 'http://www.bursthub.cn/isVisible/';
        },
        meta: {
          title: 'External Link',
          requiresAuth: false
        }
      },
      {
        path: 'submit',
        component: submit,
        meta: {
          title: 'SUBMIT',
          requiresAuth: false,
        }
      },
      {
        path: 'subscribe',
        component: subscribe,
        meta: {
          title: 'SUBSCRIBE',
          requiresAuth: true
        }
      },
      {
        path: 'PersonalCenter',
        component: PersonalCenter,
        meta: {
          title: 'PersonalCenter',
          requiresAuth: true
        }
      },
      {
        path: 'about',
        component: about,
        meta: {
          title: 'ABOUT',
          desc: 'ABOUT',
          requiresAuth: false,
        }
      },
      {
        path: 'eventsDetail',
        component: eventsDetail,
        meta: {
          title: 'EVENTS',
          desc: 'Event Detail',
          requiresAuth: false
        }
      },
      {
        path: 'Notice',
        component: Notice,
        meta: {
          title: 'MESSAGE',
          desc: 'Notice Detail',
          requiresAuth: false,
        }
      },
      {
        path: 'Circulars',
        component: Circulars,
        meta: {
          title: 'MESSAGE',
          desc: 'Circulars Detail',
          requiresAuth: false,
        }
      },
      {
        path: 'Atel',
        component: Atel,
        meta: {
          title: 'MESSAGE',
          desc: 'ATel Detail',
          requiresAuth: false,
        }
      },
      {
        path: 'Customize',
        component: Customize,
        meta: {
          title: 'MESSAGE',
          desc: 'Customize Detail',
          requiresAuth: false,
        }
      },
      {
        path: 'submitList',
        component: submitList,
        meta: {
          title: 'SUBMITLIST',
          desc: 'SubmitList Info',
          requiresAuth: false,
        }
      },
      {
        path: 'viewDataInfo',
        component: viewDataInfo,
        meta: {
          title: 'VIEWDATAINFO',
          desc: 'Submit a data display',
          requiresAuth: false,
        }
      },
      {
        path: 'showSubmitInfo',
        component: showSubmitInfo,
        meta: {
          title: 'SHOWSUBMITINFO',
          desc: '',
          requiresAuth: false,
        }
      },
    ]
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    if (localStorage.getItem('metaTitle')) {
      document.title = localStorage.getItem('metaTitle')
    } else {
      document.title = to.meta.title;
    }
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    let token = localStorage.getItem('code')
    if (!token) {
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router